/**
 * What a signed-in user without access sees instead of a screen: who to ask, not a bare error.
 */

import React from 'react';
import { useTranslate } from 'react-admin';
import { Box, Card } from '@mui/material';
import { LockOutlined as LockIcon } from '@mui/icons-material';
import { DatagridEmpty, PageTitle, SectionHeader } from '@/components/shell';

export const NoAccessNotice: React.FC = () => {
  const t = useTranslate();
  return (
    <Box sx={{ pb: 3 }}>
      <SectionHeader left={<PageTitle title={t('developers.noAccess.pageTitle')} />} />
      <Card>
        <DatagridEmpty icon={<LockIcon />} title={t('developers.noAccess.title')} hint={t('developers.noAccess.hint')} />
      </Card>
    </Box>
  );
};

export default NoAccessNotice;
